"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function processNext(next) {
  if (typeof next === 'function') {
    return react_1.default.createElement(Stage, {
      stage: next
    });
  } else {
    return next;
  }
}

function Stage(props) {
  var next = props.stage();
  return processNext(next);
}

function staged(stage) {
  return function Staged(props, ref) {
    var next = stage(props, ref);
    return processNext(next);
  };
}

exports.staged = staged;